import { render, staticRenderFns } from "./Item7Detail.vue?vue&type=template&id=6662fdb4"
import script from "./Item7Detail.vue?vue&type=script&lang=js"
export * from "./Item7Detail.vue?vue&type=script&lang=js"
import style0 from "./Item7Detail.vue?vue&type=style&index=0&id=6662fdb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports